<template>
    <div class="el-grid-card">
        <div class="el-grid-card__body">
            <el-row>
                <div class="el-grid-card__header">
                    {{ $t('title.overview') }}
                    <v-btn
                        style="
                            right: 0;
                            position: relative;
                            float: right;
                            margin-top: 10px;
                        "
                        round
                        color="primary"
                        dark
                        @click="showCreateUserView"
                        v-if="permissions.includes('USER_WRITE')"
                    >
                        {{ $t('button.text.createUser') }}
                    </v-btn>
                </div>
                <el-row>
                    <el-col :span="6" :offset="1">
                        <v-text-field
                            :label="$t('form.label.search')"
                            v-model="searchTerm"
                            append-icon="search"
                            class="el-light-search"
                        ></v-text-field>
                        <!-- amila -->
                    </el-col>
                    <el-col :span="10" :offset="7">
                        <div
                            class="el-grid-card__filter-section-right"
                            style="margin-top: 20px"
                        >
                            <el-row>
                                <el-col :span="10"
                                    ><el-checkbox
                                        v-model="includeSubContainers"
                                        @change="changeIncludeSubContainers"
                                        :label="
                                            $t(
                                                'table.column.includeSubContainers'
                                            )
                                        "
                                    ></el-checkbox>
                                </el-col>
                                <el-col :span="10">
                                    <span
                                        style="
                                            font-size: 14px;
                                            line-height: 19px;
                                            font-weight: 450;
                                            color: #606266;
                                        "
                                        >{{ $t('table.column.userStatus') }}:
                                    </span>
                                    <el-select
                                        v-model="currentUserStatus"
                                        value-key="currentUserStatus"
                                        :placeholder="
                                            $t('table.column.userStatus')
                                        "
                                        size="mini"
                                    >
                                        <el-option
                                            v-for="item in userStatusOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                            <treeselect
                                v-model="selectedContainers"
                                value-format="object"
                                class="top-multiselect"
                                :multiple="true"
                                :flat="isFlat"
                                :value-consists-of="treeValueConsistsOf"
                                :limit="treeLimit"
                                :before-clear-all="handleBeforeClearAll"
                                :placeholder="$t('form.label.selectContainers')"
                                :options="selectedContainerTree"
                                :normalizer="normalizer"
                                style="margin-top: 5px"
                            ></treeselect>
                            <br />
                            <v-btn
                                style="margin-top: 10px"
                                round
                                color="blue"
                                dark
                                @click="onApplyBtnClick(1)"
                            >
                                {{ $t('button.text.refresh') }}
                            </v-btn>
                        </div>
                    </el-col>
                </el-row>
                <el-table
                    :data="searchResults"
                    size="mini"
                    highlight-current-row
                    :empty-text="$t('message.warning.nodataSelectContainer')"
                    class="w-full mb-6"
                    style="width: 100%"
                    v-loading="loading"
                    border
                >
                    <el-table-column
                        v-for="column in columnFilterDynamicValues"
                        :key="column"
                        sortable
                        :sort-method="(a, b) => sortBy(a, b, column)"
                        :prop="column"
                        :label="setColumnHeaderLabel(column)"
                    ></el-table-column>
                    <el-table-column
                        v-if="
                            columnFilterValues.includes(
                                columnFilterInclusionList[0]
                            )
                        "
                        :label="$t('table.column.container')"
                        prop="Permissions"
                    >
                        <template slot-scope="scope">
                            {{
                                getContainerDescriptions(scope.row.Permissions)
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="
                            columnFilterValues.includes(
                                columnFilterInclusionList[1]
                            )
                        "
                        prop="Status"
                        sortable
                        :label="$t('form.label.status')"
                    >
                        <template slot-scope="{ row }">
                            <span v-if="row.Status == 0">Active</span>
                            <span v-if="row.Status == 98">Expired</span>
                            <span v-if="row.Status == 99">Deleted</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="$t('table.column.operations')"
                        width="140"
                        :resizable="false"
                    >
                        <template slot-scope="{ row }">
                            <div class="btn-action-wrapper">
                                <v-tooltip
                                    bottom
                                    v-if="isSelfCheckinUser(row)"
                                    style="display: inline !important"
                                >
                                    <v-icon
                                        slot="activator"
                                        color="orange darken-3"
                                    >
                                        flag
                                    </v-icon>
                                    <span
                                        v-html="
                                            $t('form.label.selfCheckin.user')
                                        "
                                    />
                                </v-tooltip>
                                <a
                                    href="#"
                                    class="btn-action"
                                    @click.stop="
                                        openTimeline(
                                            row.UserID,
                                            'USER',
                                            row.ReferenceCode
                                        )
                                    "
                                >
                                    <v-btn flat icon color="info darken-3">
                                        <v-icon>info</v-icon>
                                    </v-btn>
                                </a>
                                <a
                                    href="#"
                                    class="btn-action"
                                    title="Edit"
                                    @click.prevent="edit(row)"
                                    v-if="permissions.includes('USER_WRITE')"
                                >
                                    <v-btn flat icon color="cyan darken-3">
                                        <v-icon>mode_edit</v-icon>
                                    </v-btn>
                                </a>
                                <a
                                    href="#"
                                    class="btn-action"
                                    @click.prevent="remove(row)"
                                    title="Delete"
                                    v-if="
                                        row.Status !== 99 &&
                                        permissions.includes('USER_DELETE')
                                    "
                                >
                                    <v-btn flat icon color="red darken-3">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="60">
                        <template slot="header">
                            <el-popover
                                ref="fromPopOver"
                                placement="top-start"
                                width="177"
                                trigger="click"
                                @show="openMultiSelect"
                            >
                                <vue-multi-select
                                    ref="multiSelect"
                                    v-model="columnFilterValues"
                                    search
                                    historyButton
                                    :options="columnFilterOptions"
                                    :btnLabel="columnFilterBtnLabel"
                                    :selectOptions="columnFilterData"
                                >
                                    <template v-slot:option="{ option }">
                                        <input
                                            type="checkbox"
                                            :checked="option.selected"
                                        />
                                        <span>{{ option.name }}</span>
                                    </template>
                                </vue-multi-select>
                            </el-popover>
                            <span>
                                <i
                                    class="material-icons"
                                    v-popover:fromPopOver
                                    style="font-size: 20px; cursor: pointer"
                                    >filter_alt</i
                                >
                            </span>
                            <span> ({{ columnSelectedCount }}) </span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next"
                    :page-count="totalPages"
                    :total="totalCount"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 30, 40, 50, 100, 500]"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    style="margin-top: 10px"
                >
                </el-pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import InteractWithSort from '../../mixins/interact-with-sort'
import Treeselect from '@riophae/vue-treeselect'
import vueMultiSelect from 'vue-multi-select'
import 'vue-multi-select/dist/lib/vue-multi-select.css'

export default {
   name: 'user-list',

   data() {
       return {
           users: [],
           loading: false,
           showContainerAndPermissions: false,
           selectedContainers: [],
           treeValueConsistsOf: 'ALL',
           includeSubContainers: false,
           isFlat: true,
           normalizer(node) {
               let data = {
                   id: node.ContainerID,
                   label: node.Description,
               }

               if (node.Children && node.Children.length) {
                   return {
                       ...data,
                       children: node.Children,
                   }
               }

               return data
           },
           treeLimit: 2,
           unloadingAreas: [],
           totalPages: 1,
           currentPage: 1,
           totalCount: 0,
           pageSize: 10,
           searchResults: [],
           searchTerm: '',
           userStatusOptions: [
               { label: 'Active', value: 0 },
               { label: 'Expired', value: 98 },
               { label: 'Deleted', value: 99 },
           ],
           currentUserStatus: 0,

            columnFilterExclusionList: [
                'Permissions',
                'Status',
                'ContainerDescription',
                'actor',
            ],
            columnFilterInclusionList: ['Containers', 'StatusDescription'],
            columnFilterDefault: [
                'FirstName',
                'LastName',
                'UserName',
                'Company',
            ],
            columnFilterValues: [],
            columnFilterData: [],
            columnFilterOptions: {
                multi: true,
            },
            columnSelectedCount: 6,
            columnFilterBtnLabel: (values) => {
                this.columnSelectedCount = values.length
                return `Columns selected (${values.length})`
            },
        }
    },

   mixins: [InteractWithSort],

   components: {
       treeselect: Treeselect,
       vueMultiSelect,
   },

   computed: {
       ...mapGetters([
           'selectedContainer',
           'permissions',
           'containerTree',
           'containers',
       ]),
       selectedContainerTree() {
           return [this.selectedContainer]
       },
       searchOptions() {
           return {
               keys: [
                   'UserName',
                   'FirstName',
                   'LastName',
                   'Company',
                   'ContainerDescription',
               ],
           }
       },
       columnFilterDynamicValues() {
           const filtered = this.columnFilterValues.filter(
               (item) => !this.columnFilterInclusionList.includes(item)
           )
           return filtered
       },
   },

   async created() {
       this.selectedContainers = [this.selectedContainer] // Current selected parent container will be selected by default.

       Events.$on('user-updated', (containers) => {
           this.selectedContainers = containers
           this.onApply(1, containers)
       })

       // Update local (already loaded) user list response
       Events.$on('update-local-user-results-list', (val) => {
           let updatedUsers = _.cloneDeep(this.users)
           let index = _.findIndex(updatedUsers, { UserID: val.UserID })
           updatedUsers[index] = val
           this.users = updatedUsers
           this.searchResults = this.users
       })
   },

   beforeDestroy() {
       Events.$off('user-updated')
       Events.$off('update-local-user-results-list')
   },

   watch: {
       searchTerm: _.debounce(async function () {
           if (this.searchTerm !== '') {
               this.searchResults = await this.$search(
                   this.searchTerm,
                   this.users,
                   this.searchOptions
               )
           } else {
               this.searchResults = this.users
           }
       }, 500),
       selectedContainers: _.debounce(function () {
           this.$nextTick(() => {
               this.onApply(1)
           })
       }, 500),
       currentUserStatus: _.debounce(function () {
           this.$nextTick(() => {
               this.onApply(1)
           })
       }, 500),
   },

   methods: {
       getContainerDescriptions(permissionsArr) {
           let permissionIdList = _.uniq(_.map(permissionsArr, 'ContainerID'))
           let containersList = []
           permissionIdList.forEach((permissionId) => {
               this.containers.forEach((container) => {
                   if (container.ContainerID === permissionId) {
                       containersList.push(container)
                   }
               })
           })
           return _.map(containersList, 'Description').join(', ')
       },
       showCreateUserView() {
           Events.$emit('show-create-or-edit-view', true)
       },
       handleCurrentChange(val) {
           this.currentPage = val
           this.onApply(val)
       },

       handleSizeChange(val) {
           this.pageSize = val
           this.onApply(this.currentPage)
       },
       async groupByCategoryName(array, key, fn) {
           let hash = Object.create(null)
           return array.reduce(function (r, o) {
               if (!hash[o[key]]) {
                   hash[o[key]] = {}
                   hash[o[key]][key] = o[key]
                   r.push(hash[o[key]])
               }
               fn(o, hash[o[key]])
               return r
           }, [])
       },
       changeIncludeSubContainers() {
           if (this.includeSubContainers) {
               this.selectedContainers = null
               setTimeout(
                   function () {
                       this.isFlat = false
                       this.isFlat = false
                   }.bind(this),
                   1000
               )
           } else {
               this.selectedContainers = null
               setTimeout(
                   function () {
                       this.isFlat = true
                   }.bind(this),
                   1000
               )
           }
       },

       async handleBeforeClearAll() {
           try {
               await this.$confirm(
                   'Are you sure you want clear the fields?',
                   'Warning',
                   {
                       confirmButtonText: this.$i18n.i18next.t(
                           'button.text.confirm'
                       ),
                       cancelButtonText:
                           this.$i18n.i18next.t('button.text.cancel'),
                       type: 'warning',
                   }
               )
               return true
           } catch (e) {
               return false
           }
       },
       async onApplyBtnClick(currentPage) {
           this.searchTerm = ''
           if (!currentPage) {
               currentPage = 1
           }
           this.loading = true
           this.currentPage = currentPage

           if (this.selectedContainers.length === 0) {
               this.loading = false
               try {
                   this.$alert(
                       this.$i18n.i18next.t('message.warning.selectContainer'),
                       {
                           confirmButtonText: 'OK',
                       }
                   )
               } catch (e) {
                   return false
               }
               return false
           }

           let requestObj = {
               ContainerFilter: [
                   ...this.selectedContainers.map(
                       (container) => container.ContainerID
                   ),
               ],
               CurrentPage: this.currentPage,
               PageSize: this.pageSize,
               Status: this.currentUserStatus,
           }

           let { data } = await this.$http.post(
               `/Container/User/Search`,
               requestObj
           )
           this.setColumns(data.response)
           this.totalPages = data.TotalPages
           this.currentPage = data.CurrentPage
           this.totalCount = data.TotalCount
           this.users = data.response
           this.searchResults = this.users
           this.loading = false
       },

       async onApply(
           currentPage,
           containersSelected = this.selectedContainers
       ) {
           if (!currentPage) {
               currentPage = 1
           }
           this.loading = true
           this.currentPage = currentPage

           if (!containersSelected || containersSelected.length === 0) {
               this.totalPages = 1
               this.currentPage = 1
               this.totalCount = 0
               this.users = []
               this.searchResults = []
               this.loading = false
               return false
           }

           let requestObj = {
               ContainerFilter: [
                   ...containersSelected.map(
                       (container) => container.ContainerID
                   ),
               ],
               CurrentPage: this.currentPage,
               PageSize: this.pageSize,
               Status: this.currentUserStatus,
           }

            let { data } = await this.$http.post(
                `/Container/User/Search`,
                requestObj
            )
            let modifiedResponse = null
            if (data && data.response) {
                const promises = data.response.map(async (user) => {
                    let actor
                    if (user.RelatedActorID) {
                        try {
                            const res = await this.$http.get(
                                `/Actor/${user.RelatedActorID}`
                            )
                            actor = res.data
                        } catch (error) {
                            actor = null
                        }
                    }
                    return {
                        ...user,
                        actor: actor,
                    }
                })
                const usersWithActors = await Promise.all(promises)

                modifiedResponse = data.response
                if (
                    this.permissions.includes('SUPER_USER') ||
                    this.permissions.includes('SYSTEM_ADMIN')
                ) {
                    modifiedResponse = usersWithActors.map((item) => {
                        // If user.relatedactorid != null and relatedactorID != 9 and relatedactor.plateno != null return "actor.plateno", or if actor.status = 9 return "actor.plateno + ("Expired") "
                        // If user.relatedactorid != null and actor.MAIsEnabled = 1 and relatedactorID, return "Yes", "No", or "Expired" (expired if actor.status = 9)
                        let AccessControl = null
                        let AccessControlPIN = null
                        let AccessControlPlateNo = null
                        let AppAccess = 'No'

                        if (item.RelatedActorID && item.actor) {
                            if (item.actor.Status != 9) {
                                AccessControl = 'Yes'
                                AccessControlPIN = item.actor.PinCode
                                if (item.actor.PlateNo) {
                                    AccessControlPlateNo = item.actor.PlateNo
                                }
                                if (item.actor.MAIsEnabled == 1) {
                                    AppAccess = 'Yes'
                                }
                            } else if (item.actor.Status == 9) {
                                AccessControl = 'Expired'
                                AccessControlPIN = `${item.actor.PinCode} ('Expired')`
                                if (item.actor.PlateNo) {
                                    AccessControlPlateNo = `${item.actor.PlateNo} ('Expired')`
                                }
                                if (item.actor.MAIsEnabled == 1) {
                                    AppAccess = 'Expired'
                                }
                            }
                        } else {
                            AccessControl = 'No'
                        }

                        return {
                            ...item,
                            AccessControl: AccessControl,
                            AccessControlPIN: AccessControlPIN,
                            AccessControlPlateNo: AccessControlPlateNo,
                            AppAccess: AppAccess,
                        }
                    })
                }
            }

            this.setColumns(modifiedResponse)
            this.totalPages = data.TotalPages
            this.currentPage = data.CurrentPage
            this.totalCount = data.TotalCount
            this.users = modifiedResponse
            this.searchResults = this.users
            this.loading = false
        },

       edit(user) {
           this.showCreateUserView()
           this.$nextTick(() => {
               Events.$emit('user-editing', user)
           })
       },

       async remove(user) {
           try {
               await this.$confirm(
                   this.$i18n.i18next.t('message.warning.delete', {
                       section: this.$i18n.i18next.t('text.user'),
                   }),
                   'Warning',
                   {
                       confirmButtonText: this.$i18n.i18next.t(
                           'button.text.confirm'
                       ),
                       cancelButtonText:
                           this.$i18n.i18next.t('button.text.cancel'),
                       type: 'warning',
                   }
               )

               await this.$http.delete(`User/${user.UserID}`)
               await this.onApply(this.currentPage)

               this.$message({
                   type: 'success',
                   showClose: true,
                   message: this.$i18n.i18next.t('message.success.deleted', {
                       section: this.$i18n.i18next.t('text.user'),
                   }),
               })
           } catch (e) {
               if (e === 'cancel') {
                   //
               } else {
                   this.$message({
                       type: 'error',
                       showClose: true,
                       message: this.$i18n.i18next.t('message.error.general'),
                   })
               }
           }
       },

       openTimeline(id, type, code) {
           Events.$emit('show-timeline', id, type, code)
       },

       isSelfCheckinUser(user) {
           return (
               user.Permissions.filter(
                   (it) => it.Permission === 'SELF_CHECKIN'
               ).length > 0
           )
       },

       setColumns(response) {
           if (response && response[0]) {
               const filtered = Object.keys(response[0]).filter(
                   (item) => !this.columnFilterExclusionList.includes(item)
               )
               filtered.push(...this.columnFilterInclusionList)
               this.columnFilterData = filtered
               this.columnFilterValues = [
                   ...this.columnFilterDefault,
                   ...this.columnFilterInclusionList,
               ]
           }
       },

        setColumnHeaderLabel(columnHeader) {
            const header = columnHeader[0].toLowerCase() + columnHeader.slice(1)
            return this.$t('form.label.' + header)
        },

        openMultiSelect() {
            this.$nextTick(() => {
                this.$refs.multiSelect.openMultiSelect()
            })
        },
    },
}
</script>
<style>
.current-row {
   background-color: #35c8b5b8 !important;
}

.el-table tbody tr.el-table__row td .btn-action .btn {
   width: 10px;
}

.checkBoxContainer .selectItem span {
   margin-left: 5px;
}
.checkboxLayer .clearButton {
   height: 23px !important;
}
</style>
